import PropTypes from 'prop-types';
import React from 'react';

import MediaCarousel from 'dpl/components/MediaCarousel';
import Stars from 'dpl/components/Stars';
import { isMobileUA, truncateText } from 'dpl/shared/utils';
import { ShelterIndexPropTypes } from 'dpl/shared/utils/customPropTypes';

const isMobile = isMobileUA();

const imageHeight = '224px';

export default function ResultsListItem({ shelter, onClick }) {
  const {
    dog_photographs: dogPhotographs,
    dogs_count: dogsCount,
    id,
    name,
    rating,
    street_address: streetAddress,
    short_description: shortDescription
  } = shelter;

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
  return (
    <a
      className="ShelterResultsListItem pv3 pv2-lg db pointer hide-child"
      key={id}
      onClick={onClick}
      role="button"
      data-test-id={`ShelterResultsListItem--${id}`}
    >
      <div className="ShelterResultsListItem__contents flex-l">
        <div className="ShelterResultsListItem__images mb4 mb0-md h-100 bg-light-gray relative">
          <MediaCarousel
            files={dogPhotographs}
            smartImageProps={{
              Tag: 'div',
              className:
                'bg-top bg-center-l bg-center-m cover w-100 min-w-100 mw-100',
              crop: true,
              loadingClass: 'bg-light-gray'
            }}
            dimensions={{
              height: imageHeight,
              width: isMobile ? '326px' : '224px'
            }}
            arrowClassName="child f4 fw-medium white"
            leftArrowClassName="ShelterResultsListItem__imageArrow"
            rightArrowClassName="ShelterResultsListItem__imageArrow"
            bulletsContainerClassName="pv0"
            showScrims
            scrimClassName="child"
            maxBulletsPadding={1}
          />
          {dogsCount > 0 && (
            <div className="ShelterResultsListItem__number absolute bottom-1 right-1 br-100 bg-purple white flex items-center tc">
              <span className="db center">{dogsCount}</span>
            </div>
          )}
        </div>
        <div className="flex-auto-l">
          <div className="pt2-md pl6-md">
            <p className="f4 f5-md fw-medium mb1 truncate">
              <span className="ShelterResultsListItem__titleText">{name}</span>
            </p>
            <p className="mb1-lg f2 fw-normal fw-medium-l">{streetAddress}</p>
            {Boolean(rating) && (
              <div className="mb6-lg inline-flex items-center">
                <Stars
                  fullCount={parseFloat(rating)}
                  id={`shelter-item-${id}`}
                  starWidth={12}
                  totalCount={5}
                />
              </div>
            )}
            <p className="mb5 dn db-l f2 black-70">
              {truncateText(shortDescription, 116)}
            </p>
            {dogsCount > 0 && (
              <p className="f2 fw-medium">{dogsCount} adoptable dogs</p>
            )}
          </div>
        </div>
      </div>
    </a>
  );
  /* eslint-enable jsx-a11y/click-events-have-key-events */
}

ResultsListItem.propTypes = {
  shelter: PropTypes.shape(ShelterIndexPropTypes).isRequired,
  onClick: PropTypes.func.isRequired
};
